export enum PartNumberStatus {
    NOT_CONFIGURED = 0,
    CONFIGURED = 1,
    ALL = 2
}
